import React, { useRef, useEffect, useState, ChangeEvent } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import axios, { AxiosResponse } from 'axios';


import { ApiResponse } from '../../interface/IResponse';

import Layout from '../../components/Layout/AdminLayout/AdminLayout';
import helpers from '../../helpers/index';

import LoanManagementTable from '../../components/Table/LoanManagement/LoanManagementTable';
import { LoanManagementTableData, ResponseLoanManagementTableData } from '../../interface/ILoanManagement';

import loanManagementService from './loanManagementService'
import LoanReportModal from './LoanReportModal';
import { LoanReportTableData, LoanReportFilterInput } from '../../interface/ILoanReport';

import loanReportService from '../Loan/loanReportService';

function LoanManagement() {

  var dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const filterParam = searchParams.get('filter');
  const [isOpenReportModal, setOpenReportModal] = useState(false);

  const [loanManagementListData, setLoanManagementListData] = useState<LoanManagementTableData[]>([]);
  const [isReadOnly, setIsReadOnly] = useState(false);
  const [tableKey, setTableKey] = useState(0);
  const [loanReportFilterInput, setLoanReportFilterInput] = useState<LoanReportFilterInput>({
    month: 1,
    year: 25
  });
  const [loanReportTableData, setLoanReportTableData] = useState<LoanReportTableData[]>([]);

  function getPermission() {

    var permission = helpers.getPermission();
    setIsReadOnly(permission == "ReadOnly");
  }

  async function getLoanReportTableData() {

    try {

      var response: AxiosResponse<ApiResponse<LoanReportTableData[]>> = await loanReportService.listLoanReportData();

      setLoanReportTableData(response.data.result);
    }
    catch (err) {
      throw err;
    }

  }
  async function loanLoanManagementData() {

    try {

      var response: AxiosResponse<ResponseLoanManagementTableData> = await loanManagementService.listLoanManagement();

      setLoanManagementListData(response.data.result);
    }
    catch (err) {
      throw err;
    }

  }


  useEffect(function () {
    (async () => {

      document.querySelector('.loader-container')?.classList.add('loader');


      await loanLoanManagementData();
      getPermission();

      document.querySelector('.loader-container')?.classList.remove('loader');
    })();
  }, []);

  return (<Layout>
    <LoanReportModal message='testing' isOpen={isOpenReportModal} loanReportData={loanReportTableData}
      onClose={() => setOpenReportModal(false)} />

    <div className="title-container">
      <div className="dv-title">

        <h1>Loan Management</h1>

      </div>
      <div className="title-btn-container vertical-flex-bottom">
        <button type="button" id="btnGenerateReport"
          disabled={isReadOnly}
          className="btn-green-1 center-middle"
          onClick={
            async function () {

              document.querySelector('.loader-container')?.classList.add('loader');

              await getLoanReportTableData();
              setOpenReportModal(true);

              document.querySelector('.loader-container')?.classList.remove('loader');
            }
          }
        >Report & Analytics</button>
      </div>
    </div>
    <br />
    <div className="content-container">
      <div className="table-container">
        {/* <div className="width-100 right-align">
            <div className='container-fit'>
              <div className="icon-container">
                
              </div>
            </div>
          </div> */}
        <div>
          <LoanManagementTable key={tableKey} data={
            filterParam === 'pending'
              ? [...loanManagementListData]
                  .filter(x => x.totalPendingLoans > 0)
                  .sort((a, b) => b.totalPendingLoans - a.totalPendingLoans)
              : filterParam === 'ongoing'
              ? [...loanManagementListData]
                  .filter(x => x.totalOngoingLoans > 0)
                  .sort((a, b) => b.totalOngoingLoans - a.totalOngoingLoans)
              : loanManagementListData
          } onRefresh={() => {
            setTableKey(k => k + 1);
            navigate('/Admin/LoanManagement');
          }}></LoanManagementTable>
        </div>
      </div>

    </div>
  </Layout>);
}


export default LoanManagement;